import { render, staticRenderFns } from "./ModalViwCoordinador.vue?vue&type=template&id=3bcddecc&scoped=true&"
import script from "./ModalViwCoordinador.vue?vue&type=script&lang=ts&"
export * from "./ModalViwCoordinador.vue?vue&type=script&lang=ts&"
import style0 from "./ModalViwCoordinador.vue?vue&type=style&index=0&id=3bcddecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcddecc",
  null
  
)

export default component.exports